import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { TransitionState } from 'gatsby-plugin-transition-link'
import Glide from '@glidejs/glide'

import Carousel from '../components/Carousel'
import Layout from '../components/layout'
import SEO from '../components/seo'

const fallbackProjects = []
const fallbackMetadata = {
  name: 'Camille Nivollet',
  description: 'Portfolio',
}

class IndexPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      index: props.location.state && typeof props.location.state.index !== 'undefined' ? props.location.state.index.toString() : '',
    }

    this.slidePause = this.slidePause.bind(this)
    this.slidePlay = this.slidePlay.bind(this)

    this.ref = React.createRef()
  }

  componentDidMount() {
    const { data } = this.props
    const hasProjects = Boolean(
      data &&
      data.allWordpressWpProject &&
      data.allWordpressWpProject.edges &&
      data.allWordpressWpProject.edges.length
    )

    if (!hasProjects || !this.ref.current) {
      return
    }

    this.glide = new Glide(this.ref.current, {
      animationDuration: 0,
      autoplay: 9000,
      gap: 0,
      hoverpause: false,
      touchRatio: 0,
    })

    this.glide.mount()

    this.glide.on('run.before', this.glideRunBefore.bind(this))

    this.glide.on('run.after', this.glideRunAfter.bind(this))
  }

  componentWillUnmount() {
    if (this.glide) {
      this.glide.destroy()
    }
  }

  /**
   * Method just before slide will change
   */
  glideRunBefore() {
    if (!this.glide || !this.ref.current) {
      return
    }

    const index = this.glide.index

    window.setTimeout(() => {
      const slide = this.ref.current.querySelectorAll('.glide__slide')[index]

      if (slide) {
        slide.classList.remove('glide__slide--visible')
      }
    }, 1000)
  }

  /**
   * Method after slide has changed
   */
  glideRunAfter() {
    if (!this.glide || !this.ref.current) {
      return
    }

    const slide = this.ref.current.querySelectorAll('.glide__slide')[this.glide.index]

    if (slide) {
      slide.classList.add('glide__slide--visible')
    }
  }

  /**
   * Pause the slider
   */
  slidePause() {
    if (typeof this.glide !== 'undefined') {
      this.glide.pause()
    }
  }

  /**
   * Play the slider
   */
  slidePlay() {
    if (typeof this.glide !== 'undefined') {
      this.glide.play()
    }
  }

  render() {
    const { data } = this.props
    const { index } = this.state
    const projects = data && data.allWordpressWpProject ? data.allWordpressWpProject.edges : fallbackProjects
    const metadata =
      data && data.site && data.site.siteMetadata
        ? {
            name: data.site.siteMetadata.title,
            description: data.site.siteMetadata.description,
          }
        : fallbackMetadata

    return (
      <TransitionState>
        {({mount, transitionStatus}) => {
          if (transitionStatus === `exiting`) {
            this.slidePause()
          }

          return (
            <Layout
              className="home"
              handleSlidePause={this.slidePause}
              handleSlidePlay={this.slidePlay}
            >
              <SEO
                description={metadata.description}
                title={`${metadata.name} — ${metadata.description}`}
              />
              {projects.length ? (
                <Carousel projects={projects} index={index} ref={this.ref} />
              ) : (
                <section className="container" aria-live="polite">
                  <h2>Aucun projet disponible</h2>
                </section>
              )}
            </Layout>
          )
        }}
      </TransitionState>
    )
  }
}

IndexPage.propTypes = {
  data: PropTypes.object,
}

IndexPage.defaultProps = {
  data: null,
}

export const pageQuery = graphql`
  query IndexWordPressData {
    allWordpressWpProject(sort: { fields: [date], order: DESC }) {
      edges {
        node {
          featured_media {
            source_url
            alt_text
          }
          id
          path
          title
        }
      }
    }
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`

export default IndexPage
